import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import SectionRecentListings from '../PageBuilder/SectionBuilder/SectionRecentListings/SectionRecentListings';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const recentListingsSectionType = 'recentListings';

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;

  const pageData = pageAssetsData?.[camelize(ASSET_NAME)]?.data;

  // Create custom recent listings section
  const customRecentListingsSection = {
    sectionType: recentListingsSectionType,
    sectionId: 'hardcoded-recent-listings',
    numColumns: 4,
    title: {
      fieldType: 'heading1',
      content: 'New Arrivals',
    },
    // description: {
    //   fieldType: 'paragraph',
    //   content: 'Check out the latest listings from our marketplace.',
    // },
  };

  // Add custom section at the second position (index 1)
  const customSections = pageData?.sections
    ? [
        ...pageData.sections.slice(0, 1),
        customRecentListingsSection,
        ...pageData.sections.slice(1)
      ]
    : [customRecentListingsSection];

  const customPageData = pageData
    ? {
        ...pageData,
        sections: customSections,
      }
    : {
        sections: customSections,
        meta: {
          pageTitle: {
            fieldType: 'metaTitle',
            content: 'Home page',
          },
          pageDescription: {
            fieldType: 'metaDescription',
            content: 'Marketplace home page',
          },
        },
      };

  return (
    <PageBuilder
      pageAssetsData={customPageData}
      options={{
        sectionComponents: {
          [recentListingsSectionType]: { component: SectionRecentListings },
        },
      }}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
